import { Component, OnInit } from '@angular/core';
import { NxiNavigation } from '@pershing/nxi-common';
import { INavigationService } from '@pershing/pershing-core';

@Component({
    selector: 'thirdlevel-ada-nav',
    templateUrl: 'thirdlevel-navigation-ada.component.html'
})
export class ThirdLevelAdaComponent implements OnInit {
    child: any[];
    grandChild: any;
    alertsSigned: any;
    constructor(private navigationService: INavigationService) {
    }

    ngOnInit() {
        this.navigationService.getChildPage().subscribe(
            (data: any) => {
                this.child = (data && data.children) ? data.children : [];
                this.grandChild = this.navigationService.getGrandChildPageId();
            }
        );
        this.alertsSigned = (<any>window).NXIF2Container.alertsSigned;
    }

    handleThirdLevelNavigation(grandchildpage): void {
        let navigation = new NxiNavigation();
        navigation.grandchildPage = grandchildpage;
        this.navigationService.handleNavigation(navigation);
    }

    gotoPageEvent(gotoPageName): void {
        document.dispatchEvent(new CustomEvent('portal.gotoview', {
            detail: {
                'gotoPage': gotoPageName
            }
        }));
    }
}
